import { parseFunnelBoot, type FunnelBoot } from "@shared/funnelFyp";
import type { PublicFyp } from "@shared/types";

let boot: FunnelBoot | null | undefined;

/**
 * The version the Worker picked for this visitor on a FYP funnel's page
 * (server/lib/funnelEdge.ts), written into the page as #funnel-boot. Read once:
 * a later page in this tab picks the usual way.
 */
export function funnelBoot(): FunnelBoot | null {
  if (boot !== undefined) return boot;
  boot = null;
  const el = typeof document !== "undefined" ? document.getElementById("funnel-boot") : null;
  if (!el) return boot;
  el.remove();
  try {
    boot = parseFunnelBoot(JSON.parse(el.textContent ?? ""));
  } catch {
    boot = null;
  }
  return boot;
}

/** The FYP feed the Worker wrote in, for the version it was written for. */
export function bootFeed(funnelId: string, arm: string): PublicFyp | null {
  const b = funnelBoot();
  return b?.feed && b.f === funnelId && b.a === arm ? b.feed : null;
}

/** Pages whose FYP version's videos were watched through to the sales page on this load. */
const salesAfterFyp = new Set<string>();

/**
 * The visitor scrolled past a FYP version's last video: from now on the page
 * shows its sales page. The visit was the FYP version's, counted from the
 * videos, so the sales page's own tracker is not told the version — one visit,
 * never two. The order is still the version's (getFunnelTouch).
 */
export function openSalesAfterFyp(pageId: string): void {
  salesAfterFyp.add(pageId);
}

export const salesOpenedAfterFyp = (pageId: string): boolean => salesAfterFyp.has(pageId);
